import React from 'react';
import styled, { css } from 'styled-components';
import { theme } from './theme';
import { IconCheckMark } from './Icons';

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div<{ size: number }>`
  width: ${(props) => props.size && `${props.size}rem`};
  min-width: ${(props) => props.size && `${props.size}rem`};
  height: ${(props) => props.size && `${props.size}rem`};
  border-radius: 3px;
  margin-right: 1rem;
  box-sizing: border-box;
  border: 1px solid ${theme.v2.border.default};
  color: #fff;
  background-color: ${theme.v2.white};
`;

const CheckStyled = styled.div<{ padding?: boolean }>`
  position: relative;
  ${(props) =>
    props.padding &&
    css`
      padding-top: 0.5rem;
    `}
`;

const StyledCheck = styled.div<{
  width?: any;
  height?: any;
  padding?: boolean;
}>`
  background: var(--design-base-color);
  width: ${(props) => props.width && `${props.width}rem`};
  height: ${(props) => props.height && `${props.height}rem`};
  /* height: 0.8rem; */
  display: none;
  position: absolute;
  border-radius: 3px;
  top: ${(props) => (props.padding ? '7px' : '0px')};
  left: 0px;
  svg {
    font-size: 1.1rem;
  }
`;

const CheckboxContainer = styled.div<{ align?: string; alignLeft?: boolean }>`
  cursor: pointer;
  display: flex;
  margin-bottom: 1.6rem;
  align-items: ${(props) => (props.align ? 'normal' : 'center')};
  /* align-items: center; */
  position: relative;
  &:hover {
    ${StyledCheckbox} {
      color: #222;
    }
  }
  ${HiddenCheckbox} {
    border-color: ${theme.light.colors.purpleLight};
    color: #fff;
  }
  ${HiddenCheckbox}:checked {
    & ~ ${StyledCheck} {
      display: block;
      border-color: ${theme.light.colors.purpleLight};
      color: #66cc66;
    }
    & ~ ${StyledCheckbox} {
      border-color: ${theme.light.colors.purpleLight};
    }
  }

  ${(props) =>
    props.alignLeft &&
    css`
      justify-content: space-between;
    `}
`;

const StyledLabel = styled.span<{ fontSize?: number }>`
  color: ${theme.light.colors.grayUltraDark};
  font-size: ${(props) => props.fontSize}rem;
  font-family: var(--font-primary);
  letter-spacing: 0.42px;
  font-size: 1.4rem;
  margin-left: 0.4rem;
  a {
    border-bottom: 1px solid;
  }
`;

type CheckboxProps = Omit<React.HTMLProps<HTMLInputElement>, 'label'> & {
  className?: any;
  checked?: boolean;
  label: string | React.ReactNode;
  onChange?: () => void;
  size?: number;
  sizeCheck?: number;
  align?: any;
  padding?: boolean;
  alignLeft?: boolean;
  fontSize?: number;
};

export const NewCheckbox = React.forwardRef(
  (
    {
      className,
      checked,
      label,
      type,
      onChange,
      style,
      size = 1.8,
      sizeCheck = 0.3,
      align,
      padding,
      width = 1.8,
      height = 1.8,
      alignLeft,
      fontSize = 1.4,
      ...rest
    }: CheckboxProps,
    parentRef
  ) => {
    const onCheckBoxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange && onChange();
    };
    let checkBoxElement: any;
    return (
      <CheckboxContainer
        align={align}
        className={className}
        onClick={() => {
          checkBoxElement && checkBoxElement.click();
        }}
        style={style}
        alignLeft={alignLeft}
      >
        {alignLeft && <StyledLabel fontSize={fontSize}>{label}</StyledLabel>}
        <CheckStyled padding={padding}>
          <HiddenCheckbox
            checked={checked}
            {...rest}
            onChange={onCheckBoxChange}
            as="input"
            ref={(ref: any) => {
              checkBoxElement = ref;
              /** We want to access to the ref but also to have parent components access it too */
              // @ts-ignore
              parentRef && parentRef(ref);
            }}
            className="checkedInput"
          />
          <StyledCheck padding={padding} width={width} height={height}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                height: '100%',
                alignItems: 'center',
                margin: 'auto',
              }}
            >
              <IconCheckMark />
            </div>
          </StyledCheck>
          <StyledCheckbox size={size} />
        </CheckStyled>
        {!alignLeft && <StyledLabel fontSize={fontSize}>{label}</StyledLabel>}
      </CheckboxContainer>
    );
  }
);
